import { offersConstants } from '../constants/offers';

const initialState = {
  catalog: [],
  catalogFilters: {
    categories: [],
    id: null,
  },
  countries: [],
  filters: [],
  tabs: [],
};


export default (state = initialState, action = {}) => {
  switch (action.type) {
    case offersConstants.GET_LIST_SUCCESS:
      return {
        ...state,
        catalog: action.offers,
      };

    case offersConstants.SET_OFFERS_CATALOG_FILTER:
      return {
        ...state,
        catalogFilters: {
          ...state.catalogFilters,
          ...action.filter,
        },
      };

    case offersConstants.SET_OFFER_REQUEST:
      return {
        ...state,
        selected: {},
      };
    case offersConstants.SET_OFFER_SUCCESS:
      return {
        ...state,
        selected: action.offer,
      };
    case offersConstants.SET_OFFER_NEWS_REQUEST:
      return {
        ...state,
        news: [],
      };
    case offersConstants.SET_OFFER_NEWS_SUCCESS:
      return {
        ...state,
        news: action.news,
      };
    case offersConstants.SET_OFFERS_TABS_SUCCESS:
      return {
        ...state,
        tabs: action.tabs,
    };
    case offersConstants.SET_OFFERS_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.filters,
    };


    default:
      return state;
  }
};
